angular.module('dnecom')
    .controller('StoreCollectionController', StoreCollectionController);

    StoreCollectionController.$inject = ['$scope', '$rootScope', '$http', 'wizardModal', 'notifications', 'StoreUtils'];

    function StoreCollectionController($scope, $rootScope, $http, wizardModal, notifications, StoreUtils) {
        $scope.loading = false;
        $scope.collections = [];

        $scope.init = function () {
          $scope.loading = true;
          $http.get(
              Routing.generate('collections_list', { id: $scope.store.id})
          ).then(function (response) {
              $scope.collections = response.data;
              $rootScope.$broadcast('store.collection.fetch-finish', response.data);
          }).finally(function () {
              $scope.loading = false;
          });
        };

        $scope.addItem = function() {
            var modal = $scope.prepareCollectionItemModal({
                id: 0,
                name: '',
                title: '',
                slug: '',
                buttonName: ''
            }, false, $scope.store.id);

            modal.result.then(function (item) {
                $scope.loading = true;
                $http.post(Routing.generate('collection_create', {'id': $scope.store.id}), item)
                    .then(function (response) {
                        notifications.success('Collection created');
                        getCollections();
                        $rootScope.$broadcast('store.collection.add-item', response.data);
                    }, function (response) {
                        notifications.danger(response.data.message);
                    }).finally(function () {
                        $scope.loading = false;
                    });
            });
        };

        $scope.editItem = function(item) {
            var modal = $scope.prepareCollectionItemModal(item, true, $scope.store.id);

            modal.result.then(function (item) {
                $scope.loading = true;
                $http.put(Routing.generate('collection_edit', {'id': $scope.store.id, 'collectionId': item.id}), item)
                    .then(function () {
                        notifications.success('Collection saved');
                        getCollections();
                        $rootScope.$broadcast('store.collection.edit-item', item);
                    }, function (response) {
                    notifications.danger(response.data.message);
                }).finally(function () {
                    $scope.loading = false;
                });
            });
        };

        $scope.deleteItem = function(item) {
            $scope.loading = true;
            $http.delete(Routing.generate('collection_delete', {'id': $scope.store.id, 'collectionId': item.id}))
                .then(function () {
                    $rootScope.$broadcast('store.collection.delete-item', item);
                    notifications.success('Collection deleted');
                    getCollections();
                }, function (response) {
                notifications.danger(response.data.message);
            }).finally(function () {
                $scope.loading = false;
            });
        };

        $scope.prepareCollectionItemModal = function (currentCollectionItem, isInEditMode, storeId) {
            if (_.isUndefined(isInEditMode)) {
                isInEditMode = false;
            }

            return wizardModal.open({
                templateUrl: 'collectionItemModal.html',
                size: 'md',
                controller: 'CollectionItemModalController',
                resolve: {
                    collectionItem: function () {
                        return angular.copy(currentCollectionItem);
                    },
                    isInEditMode: function () {
                        return isInEditMode;
                    },
                    storeId: function () {
                        return storeId;
                    }
                }
            });
        };

        $scope.activateItem = function (item) {
            if (!item.pendingDisplayRequest) {
                item.pendingDisplayRequest = true;
                $http.post(
                    Routing.generate('collection_change_display', {'id': $scope.store.id, 'collectionId': item.id}),
                    {isDisplay: !item.isDisplay}
                )
                    .then(function () {
                        item.isDisplay = !item.isDisplay;
                        $rootScope.$broadcast('store.collection.edit-item', item);
                    }, function () {
                        notifications.danger('Something goes wrong');
                    }).finally(function () {
                        item.pendingDisplayRequest = false;
                    });
            }
        };

        $scope.$on('store.homepage-settings.collection.select', (event, collectionId) => {
            const collection = _.find($scope.collections, o => o.id === collectionId);
            if (collection && !collection.isDisplay) {
                $scope.activateItem(collection);
            }
        });

        $scope.move = function (index, direction, item) {
            item.isReordering = true;
            var nextItemIndex = direction === 'up' ? index - 1 : index + 1;
            var item2 = $scope.collections[nextItemIndex];
            item2.isReordering = true;
            $http.post(
                Routing.generate('collection_move', {
                    id: $scope.store.id,
                    collectionId: item.id,
                    direction: direction
                })
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Invalid server response.');
                    return;
                }

                $scope.collections[index] = response.data.collection;

                for (var i = 0; i < $scope.collections.length; i++) {
                    if ($scope.collections[i].id == response.data.collection2.id) {
                        $scope.collections[i] = response.data.collection2;
                        break;
                    }
                }

                sortCollections();

                notifications.success('Collection updated.');
            }, function() {
                notifications.danger('Request error.');
            }).finally(function () {
                item.isReordering = false;
                item2.isReordering = false;
            });
        };

        $scope.addProducts = function (item) {
            wizardModal.open({
                templateUrl: 'collectionProductSearchModal.html',
                size: 'md modal-collection-product',
                controller: 'CollectionProductSearchModalController',
                resolve: {
                    collectionItem: function () {
                        return item;
                    },
                    storeId: function () {
                        return $scope.store.id;
                    }
                }
            }).result.then(function () {
                $scope.loading = true;
                getCollections();
            });
        };

        $scope.openManageProducts = function (item) {
            wizardModal.open({
                templateUrl: 'collectionProductsModal.html',
                size: 'md modal-collection-product',
                controller: 'CollectionProductsModalController',
                resolve: {
                    collectionItem: function () {
                        return item;
                    },
                    storeId: function () {
                        return $scope.store.id;
                    }
                }
            }).result.then(function () {
                $scope.loading = true;
                getCollections();
            });
        };

        $scope.generateCollectionUrl = function (item) {
            return StoreUtils.generateRoute($scope.store, 'stores_fe_collections', {slug: item.slug}, true);
        };


        $scope.onSuccessCopy = function (e) {
            notifications.success('Collection URL was successfully copied to clipboard!');
        };

        var getCollections = function () {
            $http.get(
                Routing.generate('collections_list', { id: $scope.store.id})
            ).then(function (response) {
                $scope.collections = response.data;
                $scope.loading = false;
                $rootScope.$broadcast('store.collection.fetch-finish', response.data);
            })
        };

        function sortCollections() {
            $scope.collections = $scope.collections.sort(function (a, b) {
                if (a.priority === b.priority) {
                    return a.id < b.id ? -1 : 1;
                }

                return a.priority < b.priority ? -1 : 1;
            });
        }
    };

